//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'breadcrumbs-item',

  props: {
    disabled: Boolean,

    href: {
      type: String,
      default: 'javascript:;'
    },

    target: String
  },

  computed: {
    classes () {
      return {
        'breadcrumbs__item--disabled': this.disabled
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/breadcrumbs/BreadcrumbsItem.vue